import React from "react";

//COMPONENTS
import Background from "../components/Background";

const HomePage = () => {
  return (
    <div>
      <Background />
    </div>
  );
};

export default HomePage;
